import fetch from 'auth/FetchInterceptor'

const RoleService = {}

RoleService.fetch = function () {
	return fetch({
		url: '/roles',
		method: 'get'
	})
}

RoleService.create = function (data) {
	return fetch({
		url: '/roles',
		method: 'post',
		data
	})
}

RoleService.update = function (data) {
	return fetch({
		url: '/roles/' + data.id,
		method: 'put',
		data
	})
}

RoleService.delete = function (id) {
	return fetch({
		url: '/roles/' + id,
		method: 'delete',
	})
}

export default RoleService;